export default __webpack_public_path__ + "static/neue-haas-grotesk-display-55-roman-4724860d7a099d69beef919ba0cb3f07.woff2";